export default __webpack_public_path__ + "static/media/facebook.604d2ec5.svg";